import { reducerWithInitialState } from 'typescript-fsa-reducers'

import {
  EventLocationResponse,
  EventMemberResponse,
  EventPriceCategoryResponse,
  EventResponse,
  EventResultObject,
  MemberResponse,
  RelationResponse,
  StatisticResponse,
} from '../../shared/types'
import {
  setEventLocations,
  setEventMember,
  setEventPriceCategories,
  setEventResult,
  setEvents,
  setMembers,
  setRelations,
  setStatistics,
} from '../../store/data/data.actions'

export interface DataState {
  member?: MemberResponse
  events?: EventResponse
  eventPriceCategories?: EventPriceCategoryResponse
  eventMember?: EventMemberResponse
  eventLocations?: EventLocationResponse
  eventResults?: EventResultObject
  relations?: RelationResponse
  statistics?: StatisticResponse
}

const INITIAL_DATA_STATE: DataState = {
  // statistics: getMockDataStatistics(),
  eventResults: {}, // getMockDataEventResult(),
}

export const dataStateReducer = reducerWithInitialState(INITIAL_DATA_STATE)
  .case(setMembers, (state, member) => {
    return ({ ...state, member })
  })

  .case(setRelations, (state, relations) => {
    return ({ ...state, relations })
  })

  .case(setStatistics, (state, statistics) => {
    return ({ ...state, statistics })
  })

  .case(setEvents, (state, events) => {
    // sortieren nach Jahr
    const sortedEvents = { ...events }
    sortedEvents.results.sort((a, b) => {
      const yearA = a.eventFrom?.year
      const yearB = b.eventFrom?.year
      if (yearA && yearB && yearA > yearB) {
        return -1
      }
      if (yearA && yearB && yearA < yearB) {
        return 1
      }
      return 0
    })

    return ({ ...state, events })
  })

  .case(setEventMember, (state, eventMember) => {
    return ({ ...state, eventMember })
  })

  .case(setEventPriceCategories, (state, eventPriceCategories) => {
    return ({ ...state, eventPriceCategories })
  })

  .case(setEventLocations, (state, eventLocations) => {
    return ({ ...state, eventLocations })
  })

  .case(setEventResult, (state, eventResults) => {
    return ({ ...state, eventResults })
  })

  .case(setStatistics, (state, statistics) => {
    return ({ ...state, statistics })
  })
